var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 27,
    viewBox: "0 0 12 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53858 26.3781H7.61087V13.5767H11.1615L11.5419 9.27541H7.61087V6.71513C7.61087 5.71662 7.81376 5.30697 8.80285 5.30697H11.5419V0.826477H8.01665C4.2378 0.826477 2.53858 2.51626 2.53858 5.74221V9.17302H0.00244141V13.5255H2.53858V26.3781Z",
    fill: "#D19B16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredFacebook);
export default __webpack_public_path__ + "static/media/colored-facebook.42a2fe57aeb46f36233b136c6da04416.svg";
export { ForwardRef as ReactComponent };